package net.gorillagroove.util

// This lock and its implementations were lifted from Ktor.
// https://discuss.kotlinlang.org/t/replacement-for-synchronized/11240/3
internal expect class Lock() {
    fun lock()
    fun unlock()
}

internal inline fun <R> Lock.use(block: () -> R): R {
    try {
        lock()
        return block()
    } finally {
        unlock()
    }
}
